import { useState } from 'react';

interface Props {
  code: string | null;
  loading?: boolean;
}

/**
 * Badge compacto del código de cliente PAC con click-to-copy. Pensado para
 * dejarlo a la mano del comercio mientras tiene abierto el portal del banco.
 */
export default function PacCustomerCodeBadge({ code, loading }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-[11px] uppercase tracking-wide text-muted-foreground">Código cliente</span>
        <span className="inline-block h-6 w-32 animate-pulse rounded bg-slate-200 dark:bg-slate-700" />
      </div>
    );
  }
  if (!code) return null;

  return (
    <button
      type="button"
      onClick={() => void handleCopy()}
      title="Click para copiar"
      className="group inline-flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-2.5 py-1 transition hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-900/40 dark:hover:bg-slate-800"
    >
      <span className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">Código cliente</span>
      <code className="font-mono text-sm font-semibold text-flux-primary">{code}</code>
      <span className={`material-symbols-outlined text-base transition ${copied ? 'text-green-600' : 'text-muted-foreground group-hover:text-foreground'}`}>{copied ? 'check' : 'content_copy'}</span>
    </button>
  );
}
